import React from 'react';
import ErrorPage from './ErrorPage';

const ServerErrorPage = () => (
  <ErrorPage
    code="500"
    tone="danger"
    eyebrow="Server Error"
    title="Something broke on our side."
    message="An unexpected error happened while serving your request. The team has been alerted. Try again in a moment — if it keeps happening, let us know."
    primaryCta={{ label: 'Try again', onClick: () => window.location.reload() }}
    secondaryCta={{ label: 'Back to home', to: '/' }}
  />
);

export default ServerErrorPage;
